module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty2.269f8347.jpg";